import { lazy } from 'react'
import { HandheldMonitoringRBAC } from 'features/AssetManagement/pages/HandheldMonitoring/rbac'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import { ProductAssetRouter } from './productAssetRouter'
import { AssetMasterRouter } from './assetMasterRouter'
import { PurchaseOrderRouter } from './purchaseOrderRouter'
import { SupplyOrderRouter } from './supplyOrderRouter'

const HandheldMonitoring = lazy(() => import('../pages/HandheldMonitoring'))

export const HandheldMonitoringRoute: RouterFeatureInterface<
  'handheldMonitoringRoute',
  '/dashboard/handheld-monitoring'
> = {
  name: 'handheldMonitoringRoute',
  Component: HandheldMonitoring,
  path: '/dashboard/handheld-monitoring',
  routeType: 'PRIVATE',
  rbacPageID: HandheldMonitoringRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

const AssetManagementRouter = [
  ...ProductAssetRouter,
  ...AssetMasterRouter,
  ...PurchaseOrderRouter,
  ...SupplyOrderRouter,
  HandheldMonitoringRoute,
]

export const AssetManagementRouterDetail = generateRouterDetail(AssetManagementRouter)
export default AssetManagementRouter
